import { useEffect, useState } from 'react'
import Pagination from '../components/commons/Pagination'
import { getAllCategories } from '../firebase/categories'
import { formatDate } from '../utils'
import DialogCreateCategory from '../components/dialogs/DialogCreateCategory'
import { useAtom } from 'jotai'
import { showCreateCategoryModalAtom, showManageCategoryModalAtom, showManageUserModalAtom } from '../store'
import DialogManageCategory from '../components/dialogs/DialogManageCategory'
import { getListingsByCategories } from '../firebase/listings'
import { getAllUserData, searchUsers } from '../firebase/users'
import DialogManageUser from '../components/dialogs/DialogManageUser'

const UserManagement = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [users, setUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [showManageUserModal, setShowManageUserModal] = useAtom(showManageUserModalAtom)
    const fields = ["User Name", 'Email', 'Phone', 'Subscription Status', 'Total Sales', 'Account Created', ""]

    useEffect(() => {
        updateUsers()
    }, [showManageUserModal])

    const updateUsers = () => {
        getAllUserData().then((users) => {
            setUsers(users)
            // setSelectedUser(users[0])
            setLoading(false)
        })
    }

    const handleManageUser = (user) => {
        setSelectedUser(user)
        setShowManageUserModal(true)
    }

    const handleSearchUsers = (e) => {
        searchUsers(e.currentTarget.value).then((users) => {
            setUsers(users)
        })
    }

    return (
        <>
            {
                selectedUser &&
                <DialogManageUser
                    open={showManageUserModal}
                    user={selectedUser}
                    onClose={() => setShowManageUserModal(false)}
                />
            }

            <div className="px-10 py-8">
                <h1 className="text-primary text-[36px]">User Manager</h1>

                <div className='flex items-center w-[384px] rounded-[44px] h-[45px] relative bg-[#2f2f2f] pl-5 mt-4'>
                    <input
                        placeholder='Search by username or email'
                        className='text-sm text-[#959595] bg-transparent w-full'
                        onChange={handleSearchUsers}
                    >
                    </input>

                    <img src='/assets/icons/icon-search-gray.svg' alt='search' className='absolute right-5' />
                </div>

                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <div className="flex flex-col items-center">
                            <img src="/assets/icons/icon-loading.svg" alt="loading" className="w-8 h-8 animate-spin mb-4" />
                            <p className="text-white text-lg">Loading users...</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="mb-10 mt-7">
                            <div className="w-full overflow-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-[#2E2E2E] rounded-[4px] py-3 text-sm text-[#717171]">
                                            {
                                                fields.map((item, index) =>
                                                    <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}-${index}`}>
                                                        {item}
                                                    </th>
                                                )
                                            }
                                        </tr>
                                    </thead>

                                    <tbody className="text-white space-y-1 text-sm">
                                        {
                                            users.slice(8 * (currentPage - 1), 8 * currentPage).map(user =>
                                                <tr key={user.id} className='h-[70px] hover:bg-[#2F2F2F] p-2  rounded-[10px] overflow-hidden'>
                                                    {/* <td className='w-[100px] pl-2'>
                                                        <img alt='picture' src={user.picture} className='w-[55px] h-[55px] object-cover' />
                                                    </td> */}

                                                    <td className='pl-3'>
                                                        {user.displayName}
                                                    </td>

                                                    <td>
                                                        {user.email}
                                                    </td>

                                                    <td>
                                                        {user.phoneNumber}
                                                    </td>

                                                    <td>
                                                        {
                                                            user.membership === 'free' ?
                                                                <div className='uppercase bg-white rounded-[20px] text-black w-fit px-4 py-2 text-xs'>
                                                                    Free
                                                                </div> :
                                                                <div className='flex items-center uppercase rounded-[20px] text-white bg-primary w-fit px-4 py-2 text-xs'>
                                                                    <img src='/assets/icons/icon-star-fill-white.svg' alt='start' className='w-[16px] mr-1' /> {user.membership} Plan
                                                                </div>
                                                        }
                                                    </td>

                                                    <td>
                                                        {user.email}
                                                    </td>

                                                    <td>
                                                        {
                                                            user.created_at ? formatDate(user.created_at.seconds) : 'N/A'
                                                        }
                                                    </td>

                                                    <td>
                                                        <div className='flex justify-end pr-10'>
                                                            <button
                                                                className="px-6 py-2 bg-white text-black rounded-[33px]"
                                                                onClick={() => handleManageUser(user)}
                                                            >Manage User</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="mt-auto">
                            <Pagination itemsPerPage={8} totalItems={users.length} onPageChange={(v) => { setCurrentPage(v) }} />
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default UserManagement